// LegalFooter.tsx
import React from 'react';
import styled from 'styled-components';
import Colors from '../../ui/global/Colors';
import Fonts from '../../ui/global/Fonts';

const FooterContainer = styled.div`
  position: absolute;
  bottom: 5px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 25px;
  gap: 30px;
  // background-color: ${Colors.background};
`;

const FooterLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${Colors.grey6};
  font-family: ui-sans-serif, sans-serif;
  font-weight: 100;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: ${Colors.grey5};
  }
  &:active {
    text-decoration: underline;
    color: ${Colors.grey4};
  }
`;

const LegalFooter: React.FC = () => {
  return (
    <FooterContainer>
      <FooterLink onClick={() => window.open("/terms-of-service", "_blank")}>
        Terms of Service
      </FooterLink>
      <FooterLink onClick={() => window.open("/privacy-policy", "_blank")}>
        Privacy Policy
      </FooterLink>
    </FooterContainer>
  );
};

export default LegalFooter;
